import React from "react";
import Select from "react-select";

function CustomSelect({
  options,
  onChange,
  instanceId = "123",
  defaultValue,
  ...selectProps
}) {
  return (
    <Select
      options={options}
      instanceId={instanceId}
      clearIndicator
      isSearchable={false}
      onChange={onChange}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderRadius: "42px",
          width: "200px",
          height: "48px",
          border: 0,
          boxShadow: "none",
          paddingLeft: "0.5rem",
        }),

        container: (baseStyles) => ({
          ...baseStyles,
          border: "1px solid #E81E61",
          borderRadius: "42px",
          marginLeft: "10px",
        }),

        dropdownIndicator: (baseStyles) => ({
          ...baseStyles,
          color: "#414E5F",
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          width: "90%",
          marginLeft: "5%",
          borderRadius: "5px",
          marginTop: "5px",
          background: state.isFocused ? "#F1F3F6" : "white",

          color: "black",

          cursor: "pointer",
          marginBottom: state.options.length === 5 ? "10px" : "",
        }),
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: "12px",
        colors: {
          ...theme.colors,
          primary25: "#F1F3F6",
          primary50: "#F1F3F6",
          primary: "#F1F3F6",
          color: "black",
        },
      })}
      components={{
        IndicatorSeparator: () => null,
      }}
      defaultValue={defaultValue}
      {...selectProps}
    />
  );
}

export default CustomSelect;
